<template>
  <div>
    <div class="d-flex justify-space-between">
      <v-textarea
        v-model="commentText"
        :disabled="saving"
        placeholder="Add a comment"
        auto-grow
        outlined
        dense
        rows="1"
        row-height="15"
      ></v-textarea>
      <v-btn v-if="commentText" tertiary small narrow secondary @click="postComment()" class="mt-2 mx-2 px-0">
        Comment
      </v-btn>
    </div>
    <div v-for="comment in comments" :key="comment.node.id" class="my-2 d-flex">
      <user-avatar
        :profile-picture="comment.node.user.userProfile.profilePicture"
        :user="comment.node.user"
        size="30"
      />
      <v-card class="alert-grey-background mx-2 pt-2 mt-0 mb-2 flex-grow-1 pl-2" rounded="lg">
        <div class="block d-flex justify-space-between">
          <b>
            <span class="navy--text">{{ comment.node.user.firstName }} {{ comment.node.user.lastName }}</span>
          </b>
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-if="comment.node.user.id != $store.getters.user.id"
                link
                @click="reportComment(comment.node.id)"
              >
                <v-list-item-title>Report</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="comment.node.user.id == $store.getters.user.id"
                link
                @click="deleteComment(comment.node.id)"
              >
                <v-list-item-title class="p-text">Delete Comment</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <span class="p-text d-flex justify-start pb-2 text-left">{{ comment.node.text }}</span>
      </v-card>
    </div>
  </div>
</template>

<script>
import {
  CREATE_COMMENT_MUTATION,
  DELETE_COMMENT_MUTATION,
  CREATE_MODERATION_MUTATION,
} from "@/graphql/mutations/group";
import { COMMENTS_QUERY } from "@/graphql/queries/post";
import { decodeId } from "@/lib/string";
import UserAvatar from "@/components/shared/user/UserAvatar";

export default {
  name: "PostComment",
  props: {
    postId: {
      type: String,
      required: true,
    },
  },
  components: {
    UserAvatar,
  },
  data() {
    return {
      commentText: null,
      saving: false,
      comments: [],
    };
  },
  methods: {
    getId(idString) {
      return decodeId(idString);
    },
    emitCommentSaved(type) {
      this.$emit("comment-update", {
        postId: this.postId,
        type: type,
      });
    },
    async postComment() {
      this.saving = true;
      await this.$apollo.mutate({
        mutation: CREATE_COMMENT_MUTATION,
        variables: {
          text: this.commentText,
          postId: this.getId(this.postId),
        },
      });

      await this.$apollo.queries.comments.refetch({
        after: this.after,
        postId: this.postId,
      });
      this.emitCommentSaved("add");
      this.saving = false;
      this.commentText = null;
    },
    async deleteComment(id) {
      this.saving = true;
      await this.$apollo.mutate({
        mutation: DELETE_COMMENT_MUTATION,
        variables: {
          id: this.getId(id),
        },
      });

      await this.$apollo.queries.comments.refetch({
        after: this.after,
        postId: this.postId,
      });
      this.emitCommentSaved("delete");
      this.saving = false;
    },
    async reportComment(id) {
      await this.$apollo.mutate({
        mutation: CREATE_MODERATION_MUTATION,
        variables: {
          id: this.getId(id),
          type: "COMMENT",
        },
      });
    },
  },
  apollo: {
    comments: {
      query: COMMENTS_QUERY,
      variables() {
        return {
          after: this.after,
          postId: this.postId,
        };
      },
      // network-only, otherwise doesn't update the listing card nicely on update
      fetchPolicy: "network-only",
      result(response) {
        if (response.data) {
          this.loading = false;
        }
      },
      update: (data) => data.comments.edges,
    },
  },
};
</script>
